import { createRouter,createWebHistory } from 'vue-router'

import OurServices from './components/OurServices.vue'
import DevelopmentFlow from './components/DevelopmentFlow.vue'
import BusinessInfo from './components/BusinessInfo.vue'
import CustomerComments from './components/CustomerComments.vue'
import InquiryForm from './components/InquiryForm.vue'
import PrivacyPolicy from './components/PrivacyPolicy.vue'
import TrackRecord from './components/TrackRecord.vue'
import HomePage from './components/HomePage'
import QAndA from './components/QAndA'
import SalesService from './components/SalesService'
//import RePayment from './components/RePayment'
//import NotFound from './components/NotFound'

import AdminHomePage from './components/admin/HomePage'
import AdminLogin from './components/admin/AdminLogin'
import EditService from './components/admin/EditService'
import EditNews from './components/admin/EditNews'
import EditComment from './components/admin/EditComment'
import EditRecord from './components/admin/EditRecord'
import EditSite from './components/admin/EditSite'
import CheckInquiry from './components/admin/CheckInquiry'
import EditQAndA from './components/admin/EditQAndA'
import EditPolicy from './components/admin/EditPolicy'
import EditSales from './components/admin/EditSales'
import NotFound from './components/NotFound'

import store from './store'

const router = createRouter({
  scrollBehavior(to, from, savedPosition) {
    console.log("to",to);
    console.log("from",from);
    console.log("position",savedPosition);
    return {
      top: 0
    }
  },
  history:createWebHistory("/"),
  routes:[
    {path:"/column",component:HomePage,name:"home",meta:{
      title:"Hot Linux ／ WEBシステム開発（日々のコラム）",
      desc:"日々のコラムを書いています。Hot Linux代表がその日に思いついた内容です。ご依頼者様の役に立つ内容もありますのでお楽しみに。",
    },},
    {path:"/flow",component:DevelopmentFlow,name:"flow",meta:{
      title:"Hot Linux ／ WEBシステム開発（ご相談から納品まで）",
      desc:"ご相談から納品までの流れです。規模やご依頼者によって若干変わりますが、Hot Linuxでは概ねこのような流れでお取引をさせていただいております。",
    },},
    /*
    {path:"/ourservices",component:OurServices,name:"ourservices",meta:{
      title:"Hot Linux ／ WEBシステム開発（主なサービス）",
      desc:"Hot Linuxでお引き受けできる主な内容です。システム開発やシステム改修が中心です。ここにない場合もぜひご相談ください。",
    }},
    */
    {path:"/sales",component:SalesService,name:"sales",meta:{
      title:"Hot Linux ／ WEBシステム開発（すぐにご購入いただけるサービス）",
      desc:"Hot Linuxで販売中のサービスです。お打ち合わせ等なしですぐにご購入いただけます。",
    }},
    {path:"/businessinfo",component:BusinessInfo,name:"businessinfo",meta:{
      title:"Hot Linux ／ WEBシステム開発（事業者概要）",
      desc:"事業者概要",
    }},
    {path:"/customercomments",component:CustomerComments,name:"customercomments",meta:{
      title:"Hot Linux ／ WEBシステム開発（お客様の声）",
      desc:"ご依頼頂いたお客様からの声です。多くのご依頼を頂きありがとうございます！",
    }},
    {path:"/qanda",component:QAndA,name:"qanda",meta:{
      title:"Hot Linux ／ WEBシステム開発（よくある質問）",
      desc:"Hot Linuxで今までよく頂いたお問い合わせ内容です。この中に見つけられない場合は、お気軽にお問い合わせいただければと思います。",
    }},
    {path:"/inquiryform",component:InquiryForm,name:"inquiryform",meta:{
      title:"Hot Linux ／ WEBシステム開発（お問い合わせ）",
      desc:"Hot Linuxまでお気軽にご相談ください。丁寧にヒアリングさせていただいてお客様に合ったご提案をいたします。",
    }},
    {path:"/privacypolicy",component:PrivacyPolicy,name:"privacypolicy",meta:{
      title:"Hot Linux ／ WEBシステム開発（プライバシーポリシー）",
      desc:"プライバシーポリシー",
    }},
    /*
    {path:"/repayment",component:RePayment,name:"repayment",meta:{
      title:"Hot Linux ／ WEBシステム開発（返金について）",
      desc:"ご購入後の返金についてのご案内です",
    }},
    */
    {path:"/trackrecord",component:TrackRecord,name:"trackrecord",meta:{
      title:"Hot Linux ／ WEBシステム開発（開発事例）",
      desc:"Hot Linuxの開発事例です。ここに載せているのはごく一部です。まだまだ色々な内容でお引き受けしてきました。",
    }},
    {path:"/",component:OurServices,name:"ourservice",meta:{
      title:"Hot Linux ／ WEBシステム開発（主なサービス）",
      desc:"Hot Linuxでお引き受けできる主な内容です。システム開発やシステム改修が中心です。ここにない場合もぜひご相談ください。",
    }},
    {path:"/notfound",component:NotFound,name:"notfound",meta:{
      title:"Hot Linux ／ WEBシステム開発（ページが見つかりません）",
      desc:"NotFound",
    }},

    {path:"/admin",
    component:AdminHomePage,
      children:[
        {path:"login",component:AdminLogin},
        {path:"editservice",component:EditService,meta:{requiresAuth:true}},
        {path:"editsite",component:EditSite,meta:{requiresAuth:true}},
        {path:"editnews",component:EditNews,meta:{requiresAuth:true}},
        {path:"editcomment",component:EditComment,meta:{requiresAuth:true}},
        {path:"editrecord",component:EditRecord,meta:{requiresAuth:true}},
        {path:"checkinquiry",component:CheckInquiry,meta:{requiresAuth:true}},
        {path:"editqanda",component:EditQAndA,meta:{requiresAuth:true}},
        {path:"editpolicy",component:EditPolicy,meta:{requiresAuth:true}},
        {path:"editsales",component:EditSales,meta:{requiresAuth:true}},
      ]
    },

    {path:"/:pathMatch(.*)*",redirect:"/notfound"},
    //{path:"/:pathMatch(.*)*",redirect:'/'},
  ],
});

router.beforeEach((to,from,next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    if (!store.getters.loggedIn) {
      next({
        path: '/admin/login',
        query: {
          //redirect : "",
          redirect: to.fullPath,
          message: true
        }
      });
    } else {
      next();
    }
  }else{
    next();
  }
});

const DEFAULT_TITLE = "Hot Linux ／ WEBシステム開発 "
const DEFAULT_DESC = "";

router.afterEach((to) => {
  let title = ""
  to.meta.title ? title = to.meta.title : title = DEFAULT_TITLE
  document.title = title
  let desc = ""
  to.meta.desc ? desc = to.meta.desc : desc = DEFAULT_DESC
  console.log('desc',desc)
  document.querySelector('meta[name="description"]').setAttribute("content", desc);
})

export default router